import ComingSoonPage from "../ComingSoon";

export default function Reports() {
    return (
        <ComingSoonPage title={"Reports"} />
    );
}
